/**
 * Who may see the company overview.
 *
 * One definition, imported by both the topbar (which decides whether to show
 * the icon) and App.jsx (which decides whether to render the route). Two
 * copies of this list would drift, and the drift is silent: a hidden icon with
 * a reachable route, or the reverse.
 *
 * It mirrors `authorize('hr', 'pm', 'superadmin')` on routes/overview.js. The
 * server guard is the one that matters — this only decides what to put on
 * screen, so nobody is offered a door that opens onto a 403.
 */
export const OVERVIEW_ROLES = ["hr", "pm", "superadmin"];

/* Checks the ACTIVE role, not the assignable list. Someone who holds both HR
   and Employee sees the overview while signed in as HR and not while signed in
   as Employee — which is what switching role is for, and what the server does
   too: `authenticate` reads the role claim out of the token, and switchRole
   re-issues the token when you change. */
export function canSeeOverview(user) {
  return OVERVIEW_ROLES.includes(String(user?.role || "").toLowerCase());
}
